export default __webpack_public_path__ + "static/adi_head_mob-dbac9de632296ad42a271859e15f1594.png";